import { useState } from 'react';
import { Button, Skeleton } from '@dreamtree-org/twreact-ui';

const dayLabel = (iso) => new Date(iso).toLocaleDateString('en-IN', { weekday: 'short', day: '2-digit', month: 'short' });

/**
 * Day + time-window picker for pickups, drop-offs and inspections.
 * days: [{ date, slots: [{ id, label, available }] }]; value: { id, date, label } | null.
 */
export default function SlotPicker({ days, value, onChange }) {
  const [dayIdx, setDayIdx] = useState(0);
  if (!days) return <Skeleton count={2} />;
  const day = days[dayIdx] || days[0];
  return (
    <div className="space-y-3">
      <div className="-mx-1 flex gap-2 overflow-x-auto px-1 pb-1" role="group" aria-label="Day">
        {days.map((d, i) => (
          <Button key={d.date} size="sm" variant={i === dayIdx ? 'primary' : 'outline'} aria-pressed={i === dayIdx} onClick={() => setDayIdx(i)}>
            {dayLabel(d.date)}
          </Button>
        ))}
      </div>
      <div className="grid grid-cols-1 gap-2 sm:grid-cols-3" role="group" aria-label="Time window">
        {day.slots.map((s) => {
          const selected = value && value.id === s.id;
          return (
            <Button key={s.id} variant={selected ? 'primary' : 'outline'} disabled={!s.available} aria-pressed={!!selected} onClick={() => onChange({ id: s.id, date: day.date, label: s.label })}>
              {s.label}{s.available ? '' : ' (full)'}
            </Button>
          );
        })}
      </div>
      {value ? <p className="text-sm">Selected: <strong>{dayLabel(value.date)}, {value.label}</strong></p> : null}
    </div>
  );
}

export { dayLabel };
